export default __webpack_public_path__ + "static/media/Manish-Verma.f1e534c8.jpg";